/* eslint-disable react-refresh/only-export-components */
/* eslint-disable react/display-name */
import { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import LoadingUi from "../components/LoadingUi/LoadingUi";
import ForgetPasswordPage from "../pages/ForgetPassword/ForgetPasswordPage";
import ForgetPasswordConfirm from "../pages/ForgetPassword/ForgetPasswordConfirm";
import AcceptInvite from "../pages/AcceptInvite/AcceptInvite";
import HousingPages from "../pages/Housing/HousingPages/HousingPages";
import HousingDetailsPage from "../pages/Housing/HousingDetailsPage/HousingDetailsPage";
import AddHouse from "../pages/StudentProfile/AddHousing/AddHouse";
import MyHousing from "../pages/StudentProfile/MyHousing/MyHousing";
import AllHousung from "../pages/Dashboard/Housing/AllHousing/AllHousung";
import AllHousingById from "../pages/Dashboard/Housing/AllHousingById/AllHousingById";
import FindHouse from "../pages/FindHouse/FindHouse";
import MyhousingById from "../pages/StudentProfile/MyHousing/MyhousingById";
import UpdateHousingById from "../pages/StudentProfile/UpdateHousing/UpdateHousingById";
import FindMyHouse from "../pages/FindHouse/FindMyHouse";
import UpdateMyRequest from "../pages/FindHouse/UpdateMyRequest";
import HousingFormAdmin from "../pages/Dashboard/HousingFormAdmin/HousingFormAdmin";
import RouteError from "../components/Error/RouteError";
import ServiceCharge from "../pages/ServiceCharge/ServiceCharge";
import ContactPage from "../pages/Contact/Contact";
import Contact from "../pages/Contact/Contact";
import Programs from "../pages/Programs/Programs";
import ProgramDetail from "../pages/Programs/ProgramDetail";


// Loadable function
const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingUi />}>
      <Component {...props} />
    </Suspense>
  );
};

// Lazy-loaded components
const MainLayout = Loadable(lazy(() => import("../Layout/MainLayout")));
const Home = Loadable(lazy(() => import("../pages/Home/Home/Home")));
const Login = Loadable(lazy(() => import("../pages/Login/Login")));
const Register = Loadable(lazy(() => import("../pages/Register/Register")));
const Unauthorized = Loadable(
  lazy(() => import("../pages/Unauthorized/Unauthorized"))
);
const Maintenance = Loadable(
  lazy(() => import("../pages/Maintenance/Maintenance"))
);
const Insurance = Loadable(lazy(() => import("../pages/Insurance/Insurance")));
const VerifyToken = Loadable(
  lazy(() => import("../pages/Home/VerifyToken/VerifyToken"))
);
const Eligibility = Loadable(
  lazy(() => import("../pages/Eligibility/Eligibility"))
);
const Partner = Loadable(lazy(() => import("../pages/Partner/Partner")));
const PartnerApply = Loadable(lazy(() => import("../pages/Partner/PartnerApply")));
const About = Loadable(lazy(() => import("../pages/About/About")));
const PolicyPages = Loadable(
  lazy(() => import("../pages/PolicyPages/PolicyPages"))
);
const TermsAndCondition = Loadable(
  lazy(() => import("../pages/TermsAndCinditions/TermsAndCondition"))
);

import AdminOnly from "./UniEduAdminRoute";
const DashboardPrivateRoute = Loadable(
  lazy(() => import("./DashboardPrivateRoute"))
);
const DashBoardLayout = Loadable(
  lazy(() => import("../Layout/DashBoardLayout"))
);
const AllPrograms = Loadable(
  lazy(() => import("../pages/Dashboard/AllPrograms/AllPRograms"))
);
const ProgramDetails = Loadable(
  lazy(() => import("../pages/Dashboard/AllPrograms/ProgramDetails"))
);
const StudentReq = Loadable(
  lazy(() => import("../pages/Dashboard/StudentReq/StudentReq"))
);
const PartnerReq = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/PartnerRequest"))
);
const AllPartner = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/AllPartner"))
);
const PartnerStudentList = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/PartnerStudentList"))
);
const StudentDetailsPage = Loadable(
  lazy(() => import("../pages/Dashboard/StudentDetailsPage/StudentDetailsPage"))
);
const PartnerOrgDetailsPage = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/PartnerOrgDetails"))
);
const MyOrgDashboard = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/MyOrgDashboard"))
);
const PartnerProposals = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/PartnerProposals"))
);
const AdminProposals = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/AdminProposals"))
);
const UniversityAgreements = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/UniversityAgreements"))
);
const PartnerCommissions = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/PartnerCommissions"))
);
const AllUniversity = Loadable(
  lazy(() => import("../pages/Dashboard/University/AllUniversity"))
);
const UniversityDetails = Loadable(
  lazy(() => import("../pages/Dashboard/University/UniversityDetails"))
);

const StudentPrivateRoute = Loadable(
  lazy(() => import("./StudentPrivateRoute"))
);
const StudentProfile = Loadable(lazy(() => import("../Layout/StudentProfile")));
const UpdateAccount = Loadable(
  lazy(() => import("../pages/StudentProfile/UpdateAccount/UpdateAccount"))
);
const PersonalProfile = Loadable(
  lazy(() => import("../pages/StudentProfile/PersonalProfile/PersonalProfile"))
);
const EligibilityTest = Loadable(
  lazy(() => import("../pages/StudentProfile/EligibilityTest/EligibilityTest"))
);
// Profile-free eligibility check for the agency/UniEdu dashboards.
const QuickEligibilityTest = Loadable(
  lazy(() => import("../pages/Dashboard/QuickEligibility/QuickEligibilityTest"))
);
const ApplicationState = Loadable(
  lazy(() => import("../pages/StudentProfile/ApplicationState/ApplicationState"))
);
const StudentMessages = Loadable(
  lazy(() => import("../pages/StudentProfile/Messages/Messages"))
);
const StudentSettings = Loadable(
  lazy(() => import("../pages/StudentProfile/Settings/Settings"))
);
const AllUsers = Loadable(
  lazy(() => import("../pages/Dashboard/Users/AllUsers"))
);
const MyTeam = Loadable(
  lazy(() => import("../pages/Dashboard/Partners/MyTeam"))
);
const UniEduTeam = Loadable(
  lazy(() => import("../pages/Dashboard/Team/UniEduTeam"))
);
const UserDetailsPage = Loadable(
  lazy(() => import("../pages/Dashboard/Users/UserDetails"))
);
const AllGroups = Loadable(
  lazy(() => import("../pages/Dashboard/UserManagement/Group/AllGroups"))
);
const GroupDetails = Loadable(
  lazy(() => import("../pages/Dashboard/UserManagement/Group/GroupDetails"))
);
const Message = Loadable(
  lazy(() => import("../pages/Dashboard/Message/Message"))
);
const DashboardDesign = Loadable(
  lazy(() => import('../components/DashboardDesign/DashboardDesign'))
)
const AllCountries = Loadable(
  lazy(() => import('../pages/Dashboard/Global/AllCountries'))
)
const CountryDetail = Loadable(
  lazy(() => import('../pages/Dashboard/Global/CountryDetail'))
)
const KnowledgeBase = Loadable(
  lazy(() => import('../pages/Dashboard/Global/KnowledgeBase'))
)
const KnowledgeBaseDetail = Loadable(
  lazy(() => import('../pages/Dashboard/Global/KnowledgeBaseDetail'))
)

// Define routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    errorElement: <RouteError />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/sign-in", element: <Login /> },
      { path: "sign-up", element: <Register /> },
      { path: "forget-password", element: <ForgetPasswordPage /> },
      { path: "password-reset-confirm", element: <ForgetPasswordConfirm /> },
      { path: "accept-invite", element: <AcceptInvite /> },
      { path: "unauthorized", element: <Unauthorized /> },
      { path: "maintenance", element: <Maintenance /> },
      { path: "insurance", element: <Insurance /> },
      { path: "verify-email", element: <VerifyToken /> },
      { path: "eligibility", element: <Eligibility /> },
      { path: "partner", element: <Partner /> },
      { path: "partner/apply", element: <PartnerApply /> },
      { path: "about", element: <About /> },
      { path: "programs", element: <Programs /> },
      { path: "programs/:id", element: <ProgramDetail /> },
      { path: "contact", element: <Contact/> },
      { path: "service", element: <ServiceCharge /> },

      // { path: "service", element: <Services /> },
      { path: "policy", element: <PolicyPages /> },
      { path: "termsAndConditions", element: <TermsAndCondition /> },

      // Housing route
      { path: "housing", element: <HousingPages /> },
      { path: "housing/:id", element: <HousingDetailsPage /> },
    ],
  },
  {
    path: "admin/dashboard",
    element: <DashboardPrivateRoute />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <DashboardDesign /> },
      { path: "myprofile", element: <MyOrgDashboard /> },
      { path: "my-team", element: <MyTeam /> },
      { path: "programs", element: <AllPrograms /> },
      { path: "programDetails/:id", element: <ProgramDetails /> },
      { path: "partnerRequest", element: <AdminOnly title="Partner Requests"><PartnerReq /></AdminOnly> },
      { path: "allPartner", element: <AdminOnly title="Partners"><AllPartner /></AdminOnly> },
      { path: "all-partner/partnerStudentsList", element: <AdminOnly title="Partner Students"><PartnerStudentList /></AdminOnly> },
      { path: "students", element: <StudentReq /> },
      { path: "active-applications", element: <StudentReq activeOnly={true} /> },
      { path: "update-academic-profile", element: <UpdateAccount /> },
      { path: "students/:id", element: <StudentDetailsPage /> },
      { path: "partnerOrgDetails/:id", element: <AdminOnly title="Partner"><PartnerOrgDetailsPage /></AdminOnly> },
      { path: "universities", element: <AllUniversity /> },
      { path: "university/:slug", element: <UniversityDetails /> },
      { path: "housing", element: <AllHousung /> },
      { path: "housing/:id", element: <AllHousingById /> },
      { path: "housing-form", element: <HousingFormAdmin /> },
      { path: "allUsers", element: <AdminOnly title="System Users"><AllUsers /></AdminOnly> },
      { path: "uniedu-team", element: <AdminOnly title="UniEdu Team"><UniEduTeam /></AdminOnly> },
      { path: "userDetails/:id", element: <AdminOnly title="System Users"><UserDetailsPage /></AdminOnly> },
      { path: "all-groups", element: <AdminOnly title="Permission Groups"><AllGroups /></AdminOnly> },
      { path: "group-details/:id", element: <AdminOnly title="Permission Groups"><GroupDetails /></AdminOnly> },
      { path: "message", element: <Message /> },
      { path: "partner-proposals", element: <AdminOnly title="Partner Proposals"><AdminProposals /></AdminOnly> },
      { path: "my-proposals", element: <PartnerProposals /> },
      { path: "university-agreements", element: <AdminOnly title="University Agreements"><UniversityAgreements /></AdminOnly> },
      { path: "with-uniedu-agreements", element: <AdminOnly title="Partner Agreements"><PartnerCommissions /></AdminOnly> },
      { path: "countries", element: <AllCountries /> },
      { path: "countries/:id", element: <CountryDetail /> },
      { path: "eligibility-test", element: <QuickEligibilityTest /> },
      { path: "knowledge-base", element: <KnowledgeBase /> },
      { path: "knowledge-base/:id", element: <KnowledgeBaseDetail /> },
    ],
  },
  {
    path: "/student",
    element: <StudentPrivateRoute />,
    errorElement: <RouteError />,
    children: [
      { path: "academic-profile", element: <PersonalProfile /> },
      { path: "update-academic-profile", element: <UpdateAccount /> },
      { path: "personal-profile", element: <PersonalProfile /> },
      { path: "eligibility-test", element: <EligibilityTest /> },
      { path: "application-state", element: <ApplicationState /> },
      { path: "messages", element: <StudentMessages /> },
      { path: "settings", element: <StudentSettings /> },
      { path: "add-housing", element: <AddHouse /> },
      { path: "my-housing", element: <MyHousing /> },
      { path: "my-housing/:id", element: <MyhousingById /> },
      { path: "my-housing-update/:id", element: <UpdateHousingById /> },
      { path: "findHouse", element: <FindHouse /> },
      { path: "my-house-request", element: <FindMyHouse /> },
      { path: "my-house-request/:id", element: <UpdateMyRequest /> },
    ],
  },
  // Add a catch-all route to handle 404 pages
  // { path: '*', element: <Navigate to="/404" replace /> },
]);

export default router;
